import { Dispatch, SetStateAction, useState } from 'react'
import { isInvalidPersonalData } from 'src/features/simulationConfirm/helper'
import { Brand, I18NText, Position, State } from 'src/types'
import { genBaseCells } from 'src/features/generatePdf/helper/glove' // dir位置おかしい
import { genColorCellsByPosition } from 'src/features/generatePdf/helper' // dir位置おかしい
import { UseFormWatch } from 'react-hook-form'
import { emojiMatch } from 'src/features/simulationConfirm/constants'
import { usModelOfAtomsChecker } from 'src/features/brands/atoms/helper'
import { genEmbroideryCells } from 'src/features/generatePdf/helper/embroidery'
import { getOriginalEmbroideryCells } from 'src/features/generatePdf/helper/pdfDocuments/embroiderySettings'

export const emojiChecker = (text: string) => {
  const regex = new RegExp(emojiMatch)
  return regex.test(text)
}

type CanStepFurther = {
  canSave: boolean
  canInputConsumer: boolean
  canClose: boolean
  existArribaFontNoPointColor: boolean
  existEmoji: boolean
  setIsSave: Dispatch<SetStateAction<boolean>>
}

type CompareEmailWatch = UseFormWatch<{
  mailAddress: string
  mailAddress2: string
}>

export const useCanStepFurther = (
  state: State,
  brand: Brand,
  position: Position,
  isCopied: boolean,
  t: I18NText,
  watch: CompareEmailWatch
): CanStepFurther => {
  const [isSaved, setIsSave] = useState<boolean>(false)
  const watchMailAddress = watch('mailAddress')
  const watchMailAddress2 = watch('mailAddress2')

  const baseSettings = genBaseCells(state, brand, position, t)
  const colorSettings = genColorCellsByPosition(position, state, brand, t)
  const existEmbroidery = state.embroideries.filter((e) => e.content.trim().length > 0).length > 0
  const embroiderySettings = existEmbroidery ? state.embroideries.map((e) => genEmbroideryCells(e, t)).flat() : []
  const optionalEmbroideryCells = getOriginalEmbroideryCells(state, brand)
  const existInvalidPersonal = isInvalidPersonalData(state.personal)

  const existUnselectedState = [...baseSettings, ...colorSettings, ...embroiderySettings, ...optionalEmbroideryCells].some(
    (y) => y.value === 'unselected'
  )
  const existKoreanCharacterInEmbroideries = state.embroideries.some((e) => e.content.charCodeAt(0) >= 50001 && !emojiChecker(e.content))
  const isInValidMailAddress = watchMailAddress !== watchMailAddress2 || [watchMailAddress, watchMailAddress2].some((x) => x.length === 0)
  const existArribaFontNoPointColor = state.embroideries.some((e) => e.typeFace.value === 'arriba' && !e.pointColor) // only YSR

  const existEmoji = state.embroideries.map((e) => e.content).some(emojiChecker) && !usModelOfAtomsChecker(state.baseModel.productNumber)
  const canInputConsumer = ![existUnselectedState, existKoreanCharacterInEmbroideries, existArribaFontNoPointColor].includes(true)
  const canSave = [existInvalidPersonal, isSaved, isInValidMailAddress, existEmoji].every((b) => b === false)
  const canClose = (isSaved && isCopied) || (!isSaved && !isCopied)

  return {
    canSave,
    canInputConsumer,
    canClose,
    existArribaFontNoPointColor,
    existEmoji,
    setIsSave
  }
}
